<ion-header *ngIf="dataServ.menuSection">
  <ion-toolbar mode="ios">

    <ion-back-button color="dark" slot="start" defaultHref="/home" text="" icon="chevron-back"></ion-back-button>

    <ion-title class="ion-no-padding">
      <ion-text color="primary" class="ion-text-center" *ngIf="didInit">
        <h1><b [innerHtml]="dataServ.menuSection.title | caption | translate"></b></h1>
      </ion-text>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-segment *ngIf="!multipleMenuCategories" [(ngModel)]="currentDay" mode="md" scrollable>
  <ion-segment-button [value]="day" *ngFor="let day of days" [id]="day">
    <ion-label>{{day | translate}}</ion-label>
  </ion-segment-button>
</ion-segment>

<ion-segment *ngIf="selectedMenuCategory" [(ngModel)]="currentDay" mode="md" scrollable>
  <ion-segment-button [value]="day" *ngFor="let day of days" [id]="day">
    <ion-label>{{day | translate}}</ion-label>
  </ion-segment-button>
</ion-segment>

<ion-content *ngIf="didInit">

  <ion-grid *ngIf="dataServ.menuSection">

    <ion-row *ngIf="!multipleMenuCategories && dataServ.menuSection.menu_categories">
      <ng-container *ngFor="let cat of dataServ.menuSection.menu_categories">
        <ng-container *ngIf="cat.menu_items">
          <ng-container *ngFor="let item of cat.menu_items;let i = index">
            <ion-col size="12" *ngIf="currentDay | isOpen:item:'day'">
              <ion-card (click)="detail(item)" [class]="item.tags | tagClasses">
                <ion-img [src]="item.image_url" *ngIf="item.image_url"></ion-img>

                <div class="bottom">
                  <ion-text color="white">
                    <h2><b [innerHtml]="item.name | caption | translate"></b></h2>
                  </ion-text>
                  <ion-text color="light"
                    *ngIf="item.menu_item_books != null && item.menu_item_books[0].menu_item_book_details != null">
                    {{(item.menu_item_books[0].menu_item_book_details[0].start_time| overrideTimezone :
                    dataServ.rData.time_zone) }} -
                    {{(item.menu_item_books[0].menu_item_book_details[0].end_time| overrideTimezone :
                    dataServ.rData.time_zone)}}</ion-text>
                </div>

              </ion-card>


              <ion-badge *ngIf="item.show_follow && !processing && authServ.isLogged" [color]="(item.id | followControl) ? 'primary' : 'primary'
            " (click)=" follow(item)">
                <ng-container *ngIf="item.id | followControl ; else unfollow">
                  <ion-icon color="light" name="notifications"></ion-icon>
                </ng-container>
                <ng-template #unfollow>
                  <ion-icon color="light" name="notifications-off"></ion-icon>
                </ng-template>
              </ion-badge>

            </ion-col>
          </ng-container>
        </ng-container>
      </ng-container>
    </ion-row>

    <ion-row *ngIf="multipleMenuCategories && dataServ.menuSection.menu_categories && !selectedMenuCategory">
      <ion-button class="mx-auto mt-1rem" expand="block" fill="clear" shape="round">
        {{"Categories" | translate}}
      </ion-button>
      <ion-col size="12" *ngFor="let category of dataServ.menuSection.menu_categories">
        <ion-card (click)="selectThisCategory(category)">
          <ion-img [src]="category.images[0].url" *ngIf="category.images[0].url"></ion-img>
          <div class="bottom">
            <ion-text color="white">
              <h2><b [innerHtml]="category.title | caption | translate"></b></h2>
            </ion-text>
          </div>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="selectedMenuCategory">

      <ng-container *ngIf="selectedMenuCategory.menu_items">
        <ng-container *ngFor="let item of selectedMenuCategory.menu_items;let i = index">
          <ion-col size="12" *ngIf="currentDay | isOpen:item:'day'">
            <ion-card (click)="detail(item)" [class]="item.tags | tagClasses">
              <ion-img [src]="item.image_url" *ngIf="item.image_url"></ion-img>

              <div class="bottom">
                <ion-text color="white">
                  <h2><b [innerHtml]="item.name | caption | translate"></b></h2>
                </ion-text>
                <ion-text *ngIf="item.menu_item_books != null && item.menu_item_books[0].menu_item_book_details != null"
                  color="light">
                  {{(item.menu_item_books[0].menu_item_book_details[0].start_time | overrideTimezone :
                  dataServ.rData.time_zone)}} -
                  {{(item.menu_item_books[0].menu_item_book_details[0].end_time | overrideTimezone:
                  dataServ.rData.time_zone)}}
                </ion-text>

              </div>

            </ion-card>


            <ion-badge *ngIf="item.show_follow && !processing && authServ.isLogged" [color]="(item.id | followControl) ? 'primary' : 'primary'
          " (click)=" follow(item)">
              <ng-container *ngIf="item.id | followControl ; else unfollow">
                <ion-icon color="light" name="notifications"></ion-icon>
              </ng-container>
              <ng-template #unfollow>
                <ion-icon color="light" name="notifications-off"></ion-icon>
              </ng-template>
            </ion-badge>

          </ion-col>
        </ng-container>
      </ng-container>

      <ion-button class="mx-auto mt-05rem" (click)="backToCategoryList()" expand="block" fill="clear" shape="round">
        {{"Back to Categories" | translate}}
      </ion-button>

    </ion-row>
  </ion-grid>
</ion-content>